import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import Switch from "@mui/material/Switch";
import moment from "moment/moment";

const CreateWheel = (props) => {
  const { onClose, editData, open, category = "promotion", ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [des, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [code, setCode] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [image, setImage] = useState("");
  const [link, setLink] = useState("");
  const [cutoffdate, setCutoffdate] = useState("");
  const [cutofftime, setCutofftime] = useState("");
  const [startdate, setStartdate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [sort, setSort] = useState("");
  const [starting, setStarting] = useState("");
  const [ending, setEnding] = useState("");
  const [startTiming, setStartTiming] = useState("");
  const [endTiming, setEndTiming] = useState("");

  const [type, setType] = useState("");
  const [value, setValue] = useState("");
  const [mutiler, setMutiler] = useState("");
  const [prob, setProb] = useState("");
  const [color, setColor] = useState("");
  const [minPackageAmount, setMinPackageAmount] = useState("");
  const [packageId, setPackageId] = useState("");
  const [status, setStatus] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [apiData, setApiData] = useState([]);

  const params = useParams();

  useEffect(() => {
    if (startdate || startTime) {
      setStarting(startdate.concat("", startTime));

      setStartTiming(
        moment(starting, "YYYY-MM-DDHH:mm").format("YYYY-MM-DDTHH:mm:ss")
      );
    }

    if (cutoffdate || cutofftime) {
      setEnding(cutoffdate.concat("", cutofftime));

      setEndTiming(
        moment(ending, "YYYY-MM-DDHH:mm").format("YYYY-MM-DDTHH:mm:ss")
      );
    }
  });

 React.useEffect(() => {
  if (open) {
    setType("");
    setValue("");
    setMutiler("");
    setProb("");
    setMinPackageAmount("");
    setColor("");
    setPackageId("");
    setStatus(false);
    setIsActive(false);

    // Then set new values if editData exists
    if (Object.keys(editData).length !== 0) {
      // New fields
      setType(editData?.wofType || "");
      setValue(editData?.wofValue || "");
      setMutiler(editData?.wofMultiplier || "");
      setProb(editData?.wofProbability || "");
      setMinPackageAmount(String(editData?.wofPackage || ""));
      setColor(editData?.wofColor || "");
      setPackageId(editData?.packageId ? String(editData.packageId) : "");
      setStatus(editData?.wofEnable || false);
      setIsActive(editData?.wofActive || false);
    }
  }
}, [editData, open]);


  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
  const isPackage = type === "PACKAGE";
  const valid = isPackage
    ? type && prob && color && packageId
    : category === "popup"
    ? type && value && prob && color
    : type && value && mutiler && prob && minPackageAmount && color;
  if (valid) {
    const url = category === "popup" ? endPoints.api.UPDATE_POPUP_WOF : endPoints.api.UPDATE_WOF;

    const payload = {
      id: editData?.id, // assuming ID is required for update
      wofType: type,
      wofValue: isPackage ? value || 0 : value,
      wofMultiplier: isPackage ? mutiler || "1x" : mutiler,
      wofProbability: prob,
      wofPackage: isPackage ? minPackageAmount || 0 : minPackageAmount,
      wofColor: color,
      wofActive: isActive,
      wofEnable: status,
    };
    if (category === "popup") payload.packageId = isPackage && packageId ? Number(packageId) : null;

    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  } else {
    ErrorToast("All fields are required");
  }
};

   const fetchPackageData = async() => {
    setIsLoading(true);
    try {
      const url = endPoints.api.GET_ALL_PACKAGE;
      const result = await getAllData(url)
      console.log(result?.data);
      if (result?.status === "success") {
        // console.log(result?.data);
        setApiData(result?.data); 
        setIsLoading(false);
      } else {
        setIsLoading(false);
      } 
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching package data:", error);
    }finally {
      setIsLoading(false);
    }
  }
  
  useEffect(() => {
    fetchPackageData();   
}, []);


  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 435 } }}
      fullWidth 
      open={open}
      {...other}
    >
      <DialogTitle>Wheel of Fortune Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        <Form.Group className="mb-3 mt-3">
          <Form.Label>Type</Form.Label>
          <Form.Select
            value={type}
            onChange={(event) => {
              setType(event.target.value);
            }}
          >
            <option value="">Select Type</option>
            <option value="SC">SC</option>
            <option value="GC">GC</option>
            {category === "popup" && <option value="PACKAGE">Coin Package (opens buy screen)</option>}
          </Form.Select>
        </Form.Group>

        {type === "PACKAGE" && (
          <Form.Group className="mb-3">
            <Form.Label>Package to show on buy screen</Form.Label>
            <Form.Select
              value={String(packageId)}
              onChange={(e) => setPackageId(e.target.value)}
            >
              <option value="">Select Package</option>
              {apiData?.map((item) => (
                <option key={item?.id} value={String(item?.id)}>
                  {`$${item?.purchase_price}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {type !== "PACKAGE" && (
          <Form.Group className="mb-3">
            <Form.Label>Reward Value</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. 100 GC"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Form.Group>
        )}

        {category !== "popup" && (
        <Form.Group className="mb-3">
          <Form.Label>Multiplier</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. 3x"
            value={mutiler}
            onChange={(e) => setMutiler(e.target.value)}
          />
        </Form.Group>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Probability (%)</Form.Label>
          <Form.Control
            type="number"
            placeholder="e.g. 75"
            value={prob}
            onChange={(e) => setProb(e.target.value)}
          />
        </Form.Group>

       {category !== "popup" && type !== "PACKAGE" && (
       <Form.Group className="mb-3">
  <Form.Label>Min Package Amount</Form.Label>
  <Form.Select
  value={String(minPackageAmount)} // ensure string
  onChange={(e) => setMinPackageAmount(e.target.value)}
>
  <option value="">Select Package</option>
  {apiData?.map((item) => {
  return (
    <option key={item?.id} value={String(item?.purchase_price)}>
      {item?.purchase_price}
    </option>
  );
})}
</Form.Select>
</Form.Group>
       )}


         <FormControlLabel
                  control={
                    <Switch
                      name="status"
                      value={status}
                      onClick={() => {
                        setStatus(!status);
                      }}
                      defaultChecked={status}
                    />
                  }
                  labelPlacement="start"
                  label="Multiplier status"
                />

        
                         <FormControlLabel
                  control={
                    <Switch
                      name="active"
                      value={isActive}
                      onClick={() => {
                        setIsActive(!isActive);
                      }}
                      defaultChecked={isActive}
                    />
                  }
                  labelPlacement="start"
                  label="Active"
                />

      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateWheel;
